import { baseApi } from "./apiConfig.js";

// export const getSupportData = () => {
//   return baseApi
//     .get("/portal/getCmsAppContent?cmsPath=pages/faqSection")
//     .then((response) => {
//       // console.log('getSupportData:>>>>>>>>', response);
//       return response.data;
//     })
//     .catch((e) => {
//       console.log("error:", e);
//     });
// };

export const getSupportData = (pathName) => {
  return baseApi
    .get(
      encodeURI(
        `portal/get-new-cms-data/hubzuweb?template=/hubzuweb/pages/${pathName}`
      )
    )
    .then((response) => {
      // console.log("response for faqSection:", response);
      return response.data;
    })
    .catch((e) => {
      console.log("error:", e);
    });
};

export const fetchFaqs = (searchKeyword) => {
  return baseApi
    .post("/portal/faq", { searchKeyword })
    .then((response) => {
      return response.data;
    })
    .catch((e) => {
      console.log("error:", e);
    });
};
